module.exports = function() {
  return new Worker(__webpack_public_path__ + "0916b36b69c4619631cb.worker.js");
};